import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '../ui/table';
import { formatDateWithLocale } from '../../utils/dateUtils';
import { MovimientoResumen } from '../../utils/resumenMulticuenta/movimientos';
import { fmtImporteConSigno } from '../../utils/resumenMulticuenta/formato';

export interface UltimosMovimientosProps {
	movimientos: MovimientoResumen[];
	language: string;
	translate: (clave: string) => string;
	/** `AAAA` si la lista es de un año (el selector de año de arriba). */
	anio?: string;
}

/**
 * Los últimos movimientos de todos los planes (`MovementsTable` de Proa): el plan, la fecha y de
 * dónde viene, y el importe con su signo. Tabla de ancho fijo: si no, el nombre largo empuja el
 * importe fuera de la pantalla en móvil.
 */
const UltimosMovimientos: React.FC<UltimosMovimientosProps> = ({
	movimientos,
	language,
	translate,
	anio
}) => (
	<div data-testid="ultimos-movimientos">
		<p className="text-sm font-medium text-foreground">{translate('resumen.movements.title')}</p>
		{movimientos.length === 0 ? (
			<p className="mt-3 text-sm text-muted-foreground">
				{anio
					? translate('resumen.movements.emptyYear').replace('{anio}', anio)
					: translate('resumen.movements.empty')}
			</p>
		) : (
			<Table className="mt-3 table-fixed">
				<TableBody>
					{movimientos.map((movimiento) => (
						<TableRow key={movimiento.id}>
							<TableCell className="py-2">
								<div className="min-w-0">
									<p className="truncate text-sm font-medium" title={movimiento.planNombre}>
										{movimiento.planNombre}
									</p>
									<p className="text-xs text-muted-foreground">
										{formatDateWithLocale(movimiento.fecha, language, {
											day: 'numeric',
											month: 'short',
											year: 'numeric'
										})}{' '}
										· {translate(`resumen.movements.origin.${movimiento.origen}`)}
									</p>
								</div>
							</TableCell>
							<TableCell className="w-28 py-2 text-right text-sm font-medium whitespace-nowrap">
								{fmtImporteConSigno(movimiento.importe)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		)}
	</div>
);

export default UltimosMovimientos;
